import useControlledState from "@/hooks/useControlledState";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Switch, Tooltip } from "antd";
import { SwitchProps, SwitchSize } from "antd/es/switch";
import { ReactNode } from "react";
import styles from "./SwitchWithLabel.module.scss";

export interface SwitchWithLabelProps extends SwitchProps {
  size?: SwitchSize;
  onChange?: (checked: boolean) => void;
  children: ReactNode;
  tooltip?: ReactNode;
  togglePosition?: "left" | "right";
}

export default function SwitchWithLabel({
  checked: parentChecked,
  size,
  onChange,
  children,
  tooltip,
  togglePosition = "left",
}: SwitchWithLabelProps) {
  const [checked, setChecked] = useControlledState(false, parentChecked, onChange);

  const link = (
    <span
      className={styles.clickable}
      onClick={() => setChecked(!checked)}
    >
      {children}
    </span>
  );

  return (
    <div className={[styles.SwitchWithLabel, styles[size || "default"]].join(" ")}>
      {togglePosition === "right" && link}
      <Switch
        size={size}
        checked={checked}
        onChange={(e) => setChecked(e)}
      />
      {togglePosition === "left" && link}
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoCircleOutlined />
        </Tooltip>
      )}
    </div>
  );
}
